/**
 * Creates a home position marker as a yellow circle with "L" inside.
 * Returns an HTMLImageElement that can be used as a map marker.
 */
export const createHomeMarkerImage = (size = 24, yellowColor?: string, whiteColor?: string): HTMLImageElement => {
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;

  const context = canvas.getContext('2d');
  if (!context) {
    throw new Error('Could not get canvas context');
  }

  // Clear the canvas
  context.clearRect(0, 0, canvas.width, canvas.height);

  const centerX = canvas.width / 2;
  const centerY = canvas.height / 2;
  const radius = size / 2 - 2; // Leave a small margin

  // Use provided colors or fallback to theme defaults
  // Since this is a utility function, we can't use useTheme hook
  // The fallback values match the theme defaults
  const yellow = yellowColor || '#FFCA0F';
  context.beginPath();
  context.arc(centerX, centerY, radius, 0, 2 * Math.PI);
  context.fillStyle = yellow;
  context.fill();

  // Draw "L" letter inside
  const white = whiteColor || '#ffffff';
  context.fillStyle = white;
  context.font = `bold ${size * 0.6}px Arial`;
  context.textAlign = 'center';
  context.textBaseline = 'middle';
  context.fillText('L', centerX, centerY);

  // Convert canvas to image
  const img = new Image();
  img.src = canvas.toDataURL();
  img.width = size;
  img.height = size;

  return img;
};
